import './index.css';

interface Props {
  isVisible: boolean;
  zoomLevel: number | undefined;
  handleZoomIn: () => void;
  handleZoomOut: () => void;
}

const ChartZoomLevel = (props: Props) => {
  const { isVisible, zoomLevel, handleZoomIn, handleZoomOut } = props;

  if (!isVisible || !zoomLevel) {
    return null;
  }

  return (
    <div className="single-profit-calcs-chart-zoom-level-root">
      <div
        className="single-profit-calcs-chart-zoom-level-icon"
        onClick={handleZoomIn}
      >
        <span className="single-profit-calcs-chart-zoom-level-text">-</span>
      </div>
      <div className="single-profit-calcs-chart-zoom-level-container">
        <span className="single-profit-calcs-chart-zoom-level">
          {zoomLevel}
        </span>
      </div>
      <div
        className="single-profit-calcs-chart-zoom-level-icon"
        onClick={handleZoomOut}
      >
        <span className="single-profit-calcs-chart-zoom-level-text">+</span>
      </div>
    </div>
  );
};

export default ChartZoomLevel;
